import { createFileRoute } from "@tanstack/react-router";
import { PulsePage } from "@/modules/pulse/presentation/pages/PulsePage";

export const Route = createFileRoute("/_authenticated/pulse")({
  component: PulsePage,
});
